<template>
  <div :class="{ 'documents': true, 'is-loading': !loaded }">
    <fieldset>
      <legend>
        <template v-if="itemType === 'documents'">
          Others
        </template>
        <template v-if="itemType === 'documents-licences'">
          Licences
        </template>
        <template v-if="itemType === 'passports'">
          Passports
        </template>
      </legend>

      <d-alert
        v-if="referenceId === 0"
        theme="light"
        show
        class="text-center">
        You will be able to see and add {{ itemTypeName }} after saving this {{ itemName }}.
      </d-alert>

      <d-alert
        v-if="loadError"
        theme="warning"
        show
        class="text-center">
        An error occurred during loading {{ itemTypeName }}.
      </d-alert>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pr-3 mb-3">
        <d-button
          theme="success"
          @click.prevent="addDocument"
          outline
          class="ml-auto">
          Add document
        </d-button>
      </d-row>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pl-3 pr-3">
        <table class="table">
          <thead>
            <tr>
              <th v-if="itemType === 'passports'">Is default document?</th>
              <th>Name</th>
              <th>Serial number</th>
              <th>Nationality</th>
              <th>Expiry</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <documents-list-item
              v-for="(documentData, index) of documents"
              :key="'documents-list-item-' + index"
              :documentData="documentData"
              :documentType="itemType" />
          </tbody>
        </table>
      </d-row>

      <d-alert
        v-if="loaded && !loadError && referenceId !== 0 && documents.length === 0"
        theme="light"
        show
        class="text-center">
        There are no {{ itemTypeName }} for this {{ itemName }}.
      </d-alert>
    </fieldset>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import DocumentsListItem from './DocumentsListItem.vue';

export default {
  name: 'documents',
  components: {
    'documents-list-item': DocumentsListItem
  },
  props: {
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      required: true
    },
    itemType: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    }
  },
  computed: {
    itemTypeName () {
      if (this.itemType === 'documents-licences') {
        return 'licences';
      }

      if (this.itemType === 'passports') {
        return 'passports';
      }

      return 'documents';
    }
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      documents: []
    };
  },
  mounted () {
    if (this.referenceId === 0) {
      this.loaded = true;
    } else {
      this.loadDocuments();
    }

    this.$bus.$on('documents-list-reload', this.reload);
  },
  methods: {
    loadDocuments () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/' + this.itemType + '/items',
        params: {
          pagination: 0,
          where: {
            reference_id: this.referenceId,
            reference_type: this.referenceType
          }
        },
        loadedKey: 'loaded',
        outputKey: 'documents',
        errorKey: 'loadError'
      });
    },
    addDocument () {
      this.$bus.$emit('show-document-popup', 'add', this.referenceType, this.referenceId, false, this.itemType);
    },
    reload (documentType) {
      if (this.itemType === documentType) {
        this.loaded = false;
        this.loadDocuments();
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('documents-list-reload', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.documents {
  margin: 30px 0;
  position: relative;

  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }
}
</style>
